import {
  AddBasketItemPayload,
  CategoriesEmployeeOrganisation,
  MutationAddBasketItemArgs,
  MutationCreateStoreOrderArgs,
  MutationRemoveBasketItemArgs,
  MutationSetSalaryBracketArgs,
  MutationUpdateBasketItemArgs,
  PayrollPayBanner,
  PayrollPayBasket,
  PayrollPayCheckoutData,
  PayrollPayDepartment,
  PayrollPayFeaturedCategory,
  PayrollPayProductDetail,
  PayrollPayStoreOrder,
  PayrollPayStoreProducts,
  QueryCheckoutDataArgs,
  QueryDepartmentDataArgs,
  QueryLayoutDataArgs,
  QueryProductDetailArgs,
  QueryStoreBasketDataArgs,
  QueryStoreHomeBannersDataArgs,
  QueryStoreHomeDepartmentsDataArgs,
  QueryStoreHomeFeaturedCategoriesDataArgs,
  QueryStoreHomeSchemeDataArgs,
  QueryStoreProductsDataArgs,
  RemoveBasketItemPayload,
  SetSalaryBracketInput,
  StoreLayoutResponse,
  StoreScheme,
  UpdateBasketItemPayload
} from "@irati/types"
import {createUseMutation, createUseQuery} from "@irati/utils/services/apollo"
import addBasketItemMutation, {getAddBasketItemMutationKey} from "../apollo/query/AddBasketItem"
import getStoreDepartmentsQuery, {getStoreDepartmentsQueryKey} from "../apollo/query/AllDepartments"
import createStoreOrderMutation, {getCreateStoreOrderMutationKey} from "../apollo/query/CreateOrder"
import getDepartmentCategoriesQuery, {getDepartmentCategoriesQueryKey} from "../apollo/query/DepartmentCategories"
import getFeaturedCategoriesQuery, {getFeaturedCategoriesQueryKey} from "../apollo/query/FeaturedCategories"
import getLandingBannersQuery, {getLandingBannersQueryKey} from "../apollo/query/LandingBanners"
import {getLayoutDataQueryKey, layoutDataQuery} from "../apollo/query/LayoutData"
import getProductDetailQuery, {getProductDetailQueryKey} from "../apollo/query/ProductDetail"
import removeBasketItemMutation, {getRemoveBasketItemMutationKey} from "../apollo/query/RemoveBasketItem"
import {getSalaryBracketsQueryKey, salaryBracketsQuery} from "../apollo/query/SalaryBrackets"
import {setSalaryBracketMutation, setSalaryBracketMutationKey} from "../apollo/query/SetSalaryBracket"
import getBasketDataQuery, {getBasketDataQueryKey} from "../apollo/query/StoreBasketData"
import getCheckoutDataQuery, {getCheckoutDataQueryKey} from "../apollo/query/StoreCheckoutData"
import {getStoreHomeSchemeQueryKey, storeHomeSchemeQuery} from "../apollo/query/StoreHomeScheme"
import getStoreProductsQuery, {getStoreProductsQueryKey} from "../apollo/query/StoreProducts"
import updateBasketItemMutation, {getUpdateBasketItemMutationKey} from "../apollo/query/UpdateBasketItem"

export const useStoreSchemeQuery = createUseQuery<StoreScheme, QueryStoreHomeSchemeDataArgs>(storeHomeSchemeQuery, {
  key: getStoreHomeSchemeQueryKey
})

export const useStoreBannersQuery = createUseQuery<PayrollPayBanner, QueryStoreHomeBannersDataArgs>(getLandingBannersQuery, {
  key: getLandingBannersQueryKey
})

export const useFeaturedCategoriesQuery = createUseQuery<PayrollPayFeaturedCategory, QueryStoreHomeFeaturedCategoriesDataArgs>(
  getFeaturedCategoriesQuery,
  {
    key: getFeaturedCategoriesQueryKey
  }
)

export const useStoreDepartmentsQuery = createUseQuery<PayrollPayDepartment, QueryStoreHomeDepartmentsDataArgs>(getStoreDepartmentsQuery, {
  key: getStoreDepartmentsQueryKey
})

export const useLayoutDataQuery = createUseQuery<StoreLayoutResponse, QueryLayoutDataArgs>(layoutDataQuery, {
  key: getLayoutDataQueryKey
})

export const useDepartmentCategoriesQuery = createUseQuery<CategoriesEmployeeOrganisation, QueryDepartmentDataArgs>(
  getDepartmentCategoriesQuery,
  {
    key: getDepartmentCategoriesQueryKey,
    errorHandlers: [
      (code) => {
        switch (code) {
          case "PBPRPNoSalaryBracket":
            return "PBPRPNoSalaryBracket"
        }
      }
    ]
  }
)

export const useStoreProductsQuery = createUseQuery<PayrollPayStoreProducts, QueryStoreProductsDataArgs>(getStoreProductsQuery, {
  key: getStoreProductsQueryKey
})

export const useProductDetailQuery = createUseQuery<PayrollPayProductDetail, QueryProductDetailArgs>(getProductDetailQuery, {
  key: getProductDetailQueryKey
})

export const useBasketDataQuery = createUseQuery<PayrollPayBasket, QueryStoreBasketDataArgs>(getBasketDataQuery, {
  key: getBasketDataQueryKey
})

export const useAddBasketItemMutation = createUseMutation<AddBasketItemPayload, MutationAddBasketItemArgs>(addBasketItemMutation, {
  key: getAddBasketItemMutationKey
})

export const useUpdateBasketItemMutation = createUseMutation<UpdateBasketItemPayload, MutationUpdateBasketItemArgs>(
  updateBasketItemMutation,
  {
    key: getUpdateBasketItemMutationKey
  }
)

export const useRemoveBasketItemMutation = createUseMutation<RemoveBasketItemPayload, MutationRemoveBasketItemArgs>(
  removeBasketItemMutation,
  {
    key: getRemoveBasketItemMutationKey
  }
)

export const useCheckoutDataQuery = createUseQuery<PayrollPayCheckoutData, QueryCheckoutDataArgs>(getCheckoutDataQuery, {
  key: getCheckoutDataQueryKey
})

export const useCreateStoreOrderMutation = createUseMutation<PayrollPayStoreOrder, MutationCreateStoreOrderArgs>(
  createStoreOrderMutation,
  {
    key: getCreateStoreOrderMutationKey
  }
)

export const useSalaryBracketsQuery = createUseQuery(salaryBracketsQuery, {
  key: getSalaryBracketsQueryKey
})

export const useSetSalaryBracketMutation = createUseMutation<SetSalaryBracketInput, MutationSetSalaryBracketArgs>(
  setSalaryBracketMutation,
  {
    key: setSalaryBracketMutationKey
  }
)
